module.exports = __webpack_public_path__ + "img/pic6-2.46c9214c.png";